import React, { Component, useContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { mapData } from './datamapper';


import { SearchProvider } from './components/searchcontext';
import {  AuthContext } from './components/authcontext';


import PgidRedirect from './components/pgidredirect';


//sites
import Header from './components/header';
import NavbarResponsive from './components/navbar_responsive';
import Footer from './components/footer';

//sites logged out
import Login from './components/login';
import CardCarousel from './components/cardcarousel'
import PleaseLogin from './components/pleaselogin';

import Imprint from './components/user_imprint';
import Datenschutz from './components/user_datenschutz';
import AGB from './components/user_agb';
import Kontakt from './components/user_kontakt';


import Dashboard from './components/dashboard';

//sites logged in
import Merkliste from './components/merkliste';
import Warenkorb from './components/warenkorb';
import NexusSelect from './components/nexusselect';
import OrderHistoryPage from './components/bestellbuch';
import DetailPage from './components/productdetails';
import Einstellungen from './components/preferences';

import Administration from './components/admin';






const Pressewebshop = () => {

  const {loggedIn} = useContext(AuthContext);
  const [nexusSelect, setNexusSelect] = useState([]);

  function RequireAuth({ children, loggedIn }) {
    const location = useLocation();
  
    if (!loggedIn) {
      // Save the original path in state and redirect to login
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  
    return children;
  }


  
  
  useEffect(() => {
    fetch("/search")
      .then(res => res.json())
      .then(data => {
        const nexusSelect = mapData(data.records)
        setNexusSelect(nexusSelect);   // Update state with the mapped data
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);




  
  return (
    <div className="wrapper">

                          <Header  />


                          <NavbarResponsive/>

                        


                          <Routes >
                              <>

                                <Route 
                                  path="/shopinfo/:pgid" 
                                  element={<PgidRedirect />}
                                />
                                
                                <Route
                                  path="/"
                                  element={!loggedIn ? <CardCarousel /> : <p></p>}

                                />

                                <Route
                                    path="/login"
                                    element={<Login />}
                                
                                  />

                                <Route 
                                  path="/suche" 
                                  element={ 
                                      loggedIn ? (
                                        <NexusSelect nexusSelect={nexusSelect} />
                                      ) : (
                                        <PleaseLogin/>
                                      )
                                    }
                                />  

                                <Route
                                  path="/admin"
                                  element={loggedIn ? <Administration/> : <PleaseLogin/>}
                              
                                />

                                  <Route
                                  path="/texte"
                                  element={loggedIn ?  <Einstellungen /> : <PleaseLogin/>}
                              
                                />

                          
                                
                                <Route 
                                  path="/productdetails/:ean"   
                                  element={ 
                                    <RequireAuth loggedIn={loggedIn}>
                                      <DetailPage />
                                    </RequireAuth>
                                  }
                                  
                                /> 
                                        

                                <Route
                                  path="/merkliste"
                                  element={loggedIn ? <Merkliste/> : <PleaseLogin/>}
                              
                                />

                                <Route
                                  path="/einstellungen"
                                  element={loggedIn ? <Einstellungen/> : <PleaseLogin/>}
                              
                                />


                                <Route
                                  path="/warenkorb"
                                  element={loggedIn ? <Warenkorb /> : <PleaseLogin/>}
                              
                                />

                                <Route
                                  path="/bestellbuch"
                                  element={loggedIn ? <OrderHistoryPage/> : <PleaseLogin/>}
                              
                                />

                                <Route 
                                  path="/impressum"
                                  element = {<Imprint/>}
                                />

                                <Route 
                                  path="/datenschutz"
                                  element = {<Datenschutz/>}
                                />

                                <Route 
                                  path="/agb"
                                  element = {<AGB/>}
                                />
                    
                                <Route 
                                  path="/kontakt"
                                  element = {<Kontakt/>}
                                />
                                
                              </>
                          



                          </Routes>

                          <Footer />
                      </div>
      );
};




const App = () => {

  const { loggedIn } = useContext(AuthContext); 
  

  return (
    
     
          
           <SearchProvider>
            
            <Pressewebshop loggedIn={loggedIn} />      
                    
                  
           </SearchProvider>   
      
      
  );

}


export default App;

